import { useSnackbarStack } from '@superdispatch/ui';
import { useState } from 'react';
import { useDeleteACHPaymentInfo } from 'shared/modules/carrier-profile/data/CarrierProfileAPI';

export function useACHDelete() {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const { addSnackbar } = useSnackbarStack();
  const { mutate: deleteACHPayment, isPending: isDeleting } =
    useDeleteACHPaymentInfo({
      onSuccess() {
        addSnackbar('ACH payment info was deleted', { variant: 'success' });
      },
      onError({ message }) {
        addSnackbar(`Failed to delete ACH payment info: ${message}`, {
          variant: 'error',
        });
      },
    });

  return {
    isDeleting,
    openConfirm: () => {
      setDialogOpen(true);
    },
    dialogProps: {
      open: isDialogOpen,
      onClose: () => {
        setDialogOpen(false);
      },
      onConfirm: () => {
        setDialogOpen(false);
        deleteACHPayment('');
      },
    },
  };
}
